import { Component, OnInit, Input } from '@angular/core';
import { KeyBoolean } from '@approot/models';
import { LegService } from '@approot/services/leg/leg.service';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';

@Component({
  selector: 'extra-results-display',
  templateUrl: './extra-results-display.component.html',
  styleUrls: ['./extra-results-display.component.scss']
})
export class ExtraResultsDisplayComponent implements OnInit {
  @Input() pricedLeg: any;
  @Input() depositCurrency: any;
  @Input() currencyPair: any;
  @Input() baseCurrency: string;
  @Input() extraResults: string[];
  private availableResults: KeyBoolean = {};
  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService
  ) {}

  public ngOnInit() {
    this.productsConfigService.pricingResultsInfo.markUpSpecifications.forEach(
      result => (this.availableResults[result.shortName] = true)
    );
  }

  public isResultIncludedInExtras(shortName: string) {
    // sometimes things from the pricing section of the pricing response, needs to be shown
    // only show these if its in the list of extra results to be shown
    return this.extraResults.includes(shortName);
  }

  public get markUpExpanded() {
    return this.legService.markUpExpanded;
  }

  public isRowEnabled(name: string): boolean {
    return this.availableResults[name];
  }
}
